import t from"./eventEmitter.js";const e=new t;export{e as event};
